export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            有任何问题或建议，欢迎通过以下方式与我们沟通
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-lg bg-background-100 text-center border border-background-200/70">
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
              <p className="text-xs text-foreground-500 break-all">contact@91movie.example.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 text-center border border-background-200/70">
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-500">搜索：91电影视频</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 text-center border border-background-200/70">
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-edit-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">欢迎推荐优质国产影视</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}